import { styled } from '@mui/material/styles';
import { Grid } from '@mui/material';

export const SwitchGrid = styled(Grid)`
  margin-top: -15px;
  justify-content: center;
  align-items: center;
`;